import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getTransferActivityData } from "src/api/bi";
import { postExportReport } from "src/api/sp";
import { resetStore } from "src/store/actions";
import {
  TransferAcitivityInitialState,
  TransferAcitivityRequestParams
} from "../../../config/tableInterface/interface";
import { getComponentKey } from "src/utils/genericFunctions";

export const fetchTransferActivityData = createAsyncThunk(
  "reports/fetchTransferActivityData",
  (payload: TransferAcitivityRequestParams) => getTransferActivityData(payload)
);
export const postingExportTransferReportData = createAsyncThunk(
  "dashboard/postTransferActivityData",
  (payload: any) => postExportReport(payload)
);

const initialState: TransferAcitivityInitialState = {
  data: null,
  recordsCount: null,
  status: "idle",
  error: null
};

const transferActivityData = createSlice({
  name: "transferActivityData",
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(resetStore, (state, action) => {
        return initialState;
      })
      .addCase(fetchTransferActivityData.pending, (state) => {
        state.status = "pending";
        state.data = [];
      })
      .addCase(fetchTransferActivityData.fulfilled, (state, { payload }) => {
        try {
          state.status = "idle";
          if (payload?.data?.length > 0) {
            const { data } = payload;
            data[0].docId = "TOTAL";
            state.data = data?.map((item: any) => ({
              ...item,
              key: getComponentKey()
            }));
          } else {
            state.data = null;
          }
          state.recordsCount = Number(payload.recordsCount) || 0;
        } catch (e) {
          console.error(e);
          state.status = "error";
        }
      })
      .addCase(fetchTransferActivityData.rejected, (state) => {
        state.status = "error";
        state.data = null;
        state.recordsCount = 0;
      })
      .addCase(postingExportTransferReportData.pending, (state) => {
        state.status = "pending";
      })
      .addCase(
        postingExportTransferReportData.fulfilled,
        (state, { payload }) => {
          state.status = "idle";
        }
      )
      .addCase(postingExportTransferReportData.rejected, (state) => {
        state.status = "error";
      });
  }
});

export default transferActivityData.reducer;
